import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaContabilidad } from '../_contabilidad.js';

/**
 * Pasivos de la noche, pantalla 6a. Vive dentro de `_contabilidad`, así que el guardián ya se aplicó
 * y esta ruta no repite ninguna verificación. Llega a pedido por la adjudicación 41: el operario no
 * descarga nada de esto.
 */
export const rutaPasivosNoche = createRoute({
  getParentRoute: () => rutaContabilidad,
  path: '/pasivos-noche',
  component: lazyRouteComponent(() => import('./pasivos-noche-pantalla.js'), 'RutaPasivosNoche'),
});
